import TemplateLeftSection from "./TemplateLeftSection";
import OrgTemplates from "./OrgTemplates";
import GlobalTemplates from "./GlobalTemplates";

export { GlobalTemplates, OrgTemplates, TemplateLeftSection };



// WEBPACK FOOTER //
// ./src/components/TemplateV2/index.js